import { ChangeButton as changeButton } from './changeButton'
import { ProductsContainer as productsContainer } from './productsContainer'
import { Root as root } from './root'
import { Title as title } from './title'

export const Shipping = {
  changeButton,
  productsContainer,
  root,
  title
}
